<nav class="navbar navbar-dark sticky-top">
	<div class="container-fluid">
		<div class="navbar-brand">
			<!-- <input type="text" class="form-control" id="transportTemplatesName" name="name" [(ngModel)]="data.name" placeholder="Nazwa szablonu" (ngModelChange)="nameUpdated()"> -->
		</div>
		<div class="d-flex">
			<button class="btn btn-primary me-4" (click)="openTemplates()" *ngIf="!service.transports.length">
				<i class="fas fa-palette"></i> Wczytaj szablon
			</button>
			<button class="btn btn-warning me-4" (click)="resetAll()" *ngIf="service.transports.length">
				<i class="fas fa-retweet"></i> Resetuj
			</button>
			<div *ngIf="service.vehicleSelected" class="vehicleBox">
				<div class="btn btn-outline-light me-4">
					<i class="fas fa-bus"></i>
					{{ service.vehicleSelected?.name }}
					<i class="fas fa-users"></i>
					{{
						service.vehicleSelected?.seats -
							service.vehicleSelected?.occupied -
							service.vehicleSelected?.crew
					}}
				</div>
				<div class="vehicleList">
					<div
						class="btn btn-outline-light"
						*ngFor="let vehiclesItem of service.vehicles"
						(click)="service.selectVehicle(vehiclesItem)"
					>
						<i class="fas fa-bus"></i>
						{{ vehiclesItem?.name }}
						<i class="fas fa-users"></i>
						{{ vehiclesItem?.seats - vehiclesItem?.occupied - vehiclesItem?.crew }}
					</div>
					<div class="btn btn-primary" (click)="mapComponent.generateConnectionsAll()">
						<i class="fas fa-network-wired"></i>
						Wszystkie
					</div>
				</div>
			</div>
			<div *ngIf="!service.editable">
				<button class="btn btn-danger me-4" (click)="service.editable = true">
					<i class="fas fa-pencil-alt"></i> Edytduj
				</button>
				<a class="btn btn-warning me-4" routerLink="./table"> <i class="fas fa-random"></i> Rozkład </a>
			</div>
			<div *ngIf="service.editable">
				<button class="btn btn-primary me-4" (click)="mapComponent.vehiclesToggle()" *ngIf="service.editable">
					<i class="fas fa-bus"></i> Pojazdy
				</button>
				<button class="btn btn-danger me-4" (click)="submit()"><i class="fas fa-check"></i> Zapisz</button>
			</div>
		</div>
	</div>
</nav>

<app-transports-map-templates (selected)="templateSelected()"></app-transports-map-templates>

<app-map [(data)]="data" [(map)]="map" [showAdditionalCities]="true"></app-map>
